(function () {
  'use strict';

  if (window.PGCompleteSetDrawerRefreshV65) return;
  window.PGCompleteSetDrawerRefreshV65 = true;

  var upstreamFetch = window.fetch.bind(window);
  var pins = new Map();
  var reconcileTimer = null;
  var pinCleanupTimer = null;
  var observer = null;

  function requestUrl(input) {
    return typeof input === 'string' ? input : (input && input.url) || '';
  }

  function upsellVariantId(input, init) {
    var url = requestUrl(input);
    if (!/\/cart\/add\.js(?:\?|$)/.test(url)) return '';

    var body = init && init.body;
    if (typeof body !== 'string' || body.indexOf('_pg_upsell_type') === -1) return '';

    try {
      var payload = JSON.parse(body);
      var first = payload && payload.items && payload.items[0];
      return first && first.id ? String(first.id) : '';
    } catch (error) {
      return '';
    }
  }

  function parseHeader(html) {
    if (!html) return null;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    parsed.querySelectorAll('.mini-cart__item-properties .mini-cart__item-property').forEach(function (property) {
      if (/^_pg_/.test(String(property.textContent || '').trim())) property.remove();
    });
    parsed.querySelectorAll('.mini-cart__item-properties').forEach(function (properties) {
      if (!properties.querySelector('.mini-cart__item-property')) properties.remove();
    });
    return parsed;
  }

  function freshFormFromDocument(parsed) {
    return parsed && parsed.querySelector('.cart_content form[data-cart-form="mini-cart"]');
  }

  function copyInnerHtml(freshForm, currentForm, selector) {
    var source = freshForm.querySelector(selector);
    var target = currentForm.querySelector(selector);
    if (!source || !target) return false;
    target.innerHTML = source.innerHTML;
    return true;
  }

  function syncMiniCart(freshForm, currentForm) {
    var cartContent = currentForm.closest('.cart_content');
    var scrollTop = cartContent ? cartContent.scrollTop : 0;
    var changed = false;

    changed = copyInnerHtml(freshForm, currentForm, '.js-cart_items') || changed;
    changed = copyInnerHtml(freshForm, currentForm, '.js-cart_discounts') || changed;
    changed = copyInnerHtml(freshForm, currentForm, '.js-cart_subtotal') || changed;
    changed = copyInnerHtml(freshForm, currentForm, '.js-cart_savings') || changed;

    if (freshForm.hasAttribute('data-total-discount')) {
      currentForm.setAttribute('data-total-discount', freshForm.getAttribute('data-total-discount'));
    }

    currentForm.classList.toggle('hidden', freshForm.classList.contains('hidden'));
    if (cartContent) cartContent.scrollTop = scrollTop;
    return changed;
  }

  function updateCount(parsed) {
    var count = parsed && parsed.querySelector('.cart_count');
    if (!count) return;

    document.querySelectorAll('.cart_count').forEach(function (node) {
      node.textContent = count.textContent.trim();
    });
  }

  function syncFromHeader(html) {
    var parsed = parseHeader(html);
    var fresh = freshFormFromDocument(parsed);
    var currentForms = document.querySelectorAll('.cart_content form[data-cart-form="mini-cart"]');
    if (!fresh || !currentForms.length) return false;

    var changed = false;
    currentForms.forEach(function (current) {
      changed = syncMiniCart(fresh, current) || changed;
    });
    updateCount(parsed);
    return changed;
  }

  function lineFromHeader(html, variantId) {
    var parsed = parseHeader(html);
    if (!parsed || !variantId) return '';
    var line = parsed.querySelector('.js-cart_items [data-variant-id="' + variantId + '"]');
    return line ? line.outerHTML : '';
  }

  function rememberPin(variantId, lineHtml) {
    if (!variantId || !lineHtml) return;
    pins.set(String(variantId), {
      html: lineHtml,
      expiresAt: Date.now() + 5000
    });
    schedulePinCleanup();
  }

  function revealVariant(variantId) {
    if (!variantId) return;
    var line = document.querySelector('.cart_content form[data-cart-form="mini-cart"] .js-cart_items [data-variant-id="' + variantId + '"]');
    if (!line || !line.scrollIntoView) return;
    line.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function schedulePinCleanup() {
    window.clearTimeout(pinCleanupTimer);
    pinCleanupTimer = window.setTimeout(function () {
      var now = Date.now();
      pins.forEach(function (pin, key) {
        if (!pin || pin.expiresAt <= now) pins.delete(key);
      });
      if (pins.size) schedulePinCleanup();
    }, 900);
  }

  function ensurePinnedLines() {
    if (!pins.size) return;
    var now = Date.now();

    document.querySelectorAll('.cart_content form[data-cart-form="mini-cart"] .js-cart_items').forEach(function (items) {
      pins.forEach(function (pin, variantId) {
        if (!pin || pin.expiresAt <= now) {
          pins.delete(variantId);
          return;
        }
        if (items.querySelector('[data-variant-id="' + variantId + '"]')) return;

        var parsed = new DOMParser().parseFromString('<ul>' + pin.html + '</ul>', 'text/html');
        var line = parsed.querySelector('[data-variant-id="' + variantId + '"]');
        if (line) items.appendChild(document.importNode ? document.importNode(line, true) : line.cloneNode(true));
      });
    });
  }

  function sectionUrl() {
    var url = new URL(window.location.href);
    url.searchParams.set('sections', 'header');
    url.searchParams.set('pg_cart_refresh', String(Date.now()));
    return url.pathname + url.search;
  }

  async function refreshFromServer() {
    try {
      var response = await upstreamFetch(sectionUrl(), {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        cache: 'no-store'
      });
      if (!response.ok) return false;

      var sections = await response.json();
      var html = sections && sections.header;
      if (!html) return false;

      pins.forEach(function (pin, variantId) {
        var freshLine = lineFromHeader(html, variantId);
        if (freshLine) rememberPin(variantId, freshLine);
      });

      var changed = syncFromHeader(html);
      ensurePinnedLines();
      return changed;
    } catch (error) {
      console.warn('[Paw & Glory] Complete the Set drawer reconcile failed.', error);
      ensurePinnedLines();
      return false;
    }
  }

  function scheduleReconcile(delay) {
    window.clearTimeout(reconcileTimer);
    reconcileTimer = window.setTimeout(refreshFromServer, delay == null ? 0 : delay);
  }

  function handleUpsellResponse(response, variantId) {
    if (!response || !response.ok || !variantId) return;

    response.clone().json().then(function (payload) {
      var html = payload && payload.sections && payload.sections.header;
      if (html) {
        var lineHtml = lineFromHeader(html, variantId);
        if (lineHtml) rememberPin(variantId, lineHtml);
        syncFromHeader(html);
        ensurePinnedLines();
        revealVariant(variantId);
      }

      scheduleReconcile(0);
      window.setTimeout(function () {
        ensurePinnedLines();
        revealVariant(variantId);
        refreshFromServer();
      }, 350);
    }).catch(function () {
      scheduleReconcile(0);
    });
  }

  window.fetch = function (input, init) {
    var variantId = upsellVariantId(input, init);
    var request = upstreamFetch(input, init);

    if (!variantId) return request;

    return request.then(function (response) {
      handleUpsellResponse(response, variantId);
      return response;
    });
  };

  function mutationTouchesItems(mutation) {
    var target = mutation.target && mutation.target.nodeType === 1
      ? mutation.target
      : mutation.target && mutation.target.parentElement;
    return Boolean(target && target.closest && target.closest('.cart_content .js-cart_items'));
  }

  function initObserver() {
    if (!window.MutationObserver || !document.body || observer) return;
    observer = new MutationObserver(function (mutations) {
      if (!pins.size || !mutations.some(mutationTouchesItems)) return;
      window.setTimeout(ensurePinnedLines, 0);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('pg:complete-set-discount-applied', function () {
    scheduleReconcile(0);
  });
  document.addEventListener('pg:complete-set-discount-error', function () {
    scheduleReconcile(0);
  });
  document.addEventListener('pg:cart-synchronised', function () {
    scheduleReconcile(0);
  });
  // A drawer opened after a cart-page quantity or reward change must not
  // display old product rows or an old subtotal from the previous section render.
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('.mini_cart')) {
      scheduleReconcile(0);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver, { once: true });
  } else {
    initObserver();
  }
})();
